/**
 * BL-0513 — Détecte si une URL de fichier doit être fetchée avec le JWT (API same-origin).
 *
 * Aligné sur U2000Axios : base = VITE_API_URL trimé non vide, sinon `${origin}/api`.
 * Ne jamais utiliser `fileUrl.startsWith("")` (toujours vrai quand VITE_API_URL est vide en prod).
 */

export type U2000ApiSameOriginFileUrlOptions = {
  /** Override de `import.meta.env.VITE_API_URL` (tests). */
  viteApiUrl?: string | undefined;
  /** Override de `window.location.origin` (tests / hors navigateur). */
  origin?: string | undefined;
};

export function u2000ResolveApiFileBaseUrl(
  options: U2000ApiSameOriginFileUrlOptions = {},
): string {
  const raw =
    options.viteApiUrl !== undefined
      ? options.viteApiUrl
      : (import.meta.env.VITE_API_URL as string | undefined);
  const configured = (raw ?? '').trim().replace(/\/$/, '');
  if (configured) {
    return configured;
  }
  const origin =
    options.origin !== undefined
      ? options.origin
      : typeof window !== 'undefined' && window.location?.origin
        ? window.location.origin
        : '';
  if (!origin) {
    return '';
  }
  return `${origin}/api`;
}

/**
 * @returns true si l’URL est un chemin relatif `/…` ou préfixée par la base API réelle.
 */
export function u2000IsApiSameOriginFileUrl(
  fileUrl: string,
  options: U2000ApiSameOriginFileUrlOptions = {},
): boolean {
  if (!fileUrl) {
    return false;
  }
  if (fileUrl.startsWith('/')) {
    return true;
  }
  const apiBase = u2000ResolveApiFileBaseUrl(options);
  if (!apiBase) {
    return false;
  }
  return fileUrl.startsWith(apiBase);
}
